import React from 'react';
import firebase from '../Firebase';

class VideoExporter extends React.Component {

  constructor(props){
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.loadVideo();
  }

  loadVideo = () => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user != null) {
        const db = firebase.firestore();
        const uid = firebase.auth().currentUser.uid;

        const { vid } = this.props.match.params;
        this.videoDocRef = db.collection("users").doc(uid).collection("videos").doc(vid);
        this.videoDocRef.get().then((result) => {
          var videoData = result.data();
          this.setState({ videoName: videoData.videoName, subtitledVideoUrl: videoData.subtitledVideoUrl });
        });
      }
    });
  }

  generateVideoThumbnails = () => {
    
  }

  generatedVideo = () => {
    if(this.state.subtitledVideoUrl){
      return <video id="videoPlayer" src={this.state.subtitledVideoUrl} controls />
    }else{
      return <img src="/video-placeholder.png" />
    }
  }

  render(){
    const { vid } = this.props.match.params;

    return (
      <div>
        <h1>Export - {this.state.videoName}</h1>
          { this.generatedVideo() }
        <p>
          <button onClick={this.generateVideoThumbnails}>Export</button>
        </p>
      </div>
    );
  }
}

export default VideoExporter;